import Vue from 'vue';

// This is an 'EventBus'

// Pattern:
  // Component A
    // EventBus.$emit('EVENT_NAME', payload)
  // Component B
    // mounted()
      // EventBus.$on('EVENT_NAME', function(payload))

// It is a simpler alternative to Vuex for a very straight-forward use case where you want to keep state local to a component, but want to emit events
// The EventBus.$on() really shouldn't be used more than once, if it is, should probably make a Vuex store

const HideListViewBus = new Vue();

export default HideListViewBus;